import App from './App.svelte';
import global from "../public/global.css";
import queryString from 'query-string';
import regeneratorRuntime from "regenerator-runtime";

let qs = {};
if (typeof window !== 'undefined') {
	qs = queryString.parse(window.location.search);
}

// TODO: load data from query string?

const app = new App({
	target: document.body,
	props: {
		/*
		venueName: 'Fiserv Forum',
		leagueCode: 'nba',
		teamCode: 'mil',
		teamCity: 'Milwaukee',
		teamMascot: 'Bucks',
		colorPrimary: '#00471B',
		colorSecondary: '#F0EBD2',
		iOSTicketsUrl: 'yc-nba-mil://feature/TM_PRESENCE?hostKey=yAUJaeBFqxDwvNHnMKgrco6CYumy59hB&teamDisplayName=Bucks%20%26%20Fiserv%20Forum&newAccountManager=true&expSubDomain=bucks&expAppSource=bucks&expAppID=46&expAPIKey=qV1rwgLkfBZK7oUBSnUr0W9P&expAppName=bucks&expAPIVersion=toad&loginButton=createAccount&logInToSSO=true',
		androidTicketsUrl: 'yc-nba-mil://feature/TM_PRESENCE?clientID=bucks.sdk&uwdKey=56E7C0FD-C980-0CE3-E053-33AAA8C06719&hostKey=AZII1ixmT1duLDonbSjEtZhw3DzYATxw&hostSecret=bzSOaYY7NJFkyywH&teamDisplayName=Bucks%20%26%20Fiserv%20Forum&redirectURI=https%3A%2F%2Fmilwaukeebucks.callback.com&expSubDomain=bucks&expAppSource=bucks&expAppID=46&expAPIKey=qV1rwgLkfBZK7oUBSnUr0W9P&expAppName=bucks&expAPIVersion=toad&loginButton=createAccount&logInToSSO=true',
		questions: [
			{
				text: "In the past 10 days have you experienced any of the following new or worsening symptoms?<br>• Fever<br>• Shortness of breath or difficulty breathing<br>• Sinus congestion or runny nose<br>• Loss of taste or smell<br>• Persistent cough",
				options: [
					{
						text: "No",
						allowed: true
					},
					{
						text: "Yes",
						allowed: false
					}
				],
				required: true,
				maxSelections: 1,
			},
			{
				text: "In the past 10 days have you experienced any of the following new or worsening symptoms?<br>• Nausea, vomiting, diarrhea or loss of appetite<br>• Headaches or sore throat<br>• Severe muscle aches<br>• Fatigue",
				options: [
					{
						text: "No",
						allowed: true
					},
					{
						text: "Yes",
						allowed: false
					}
				],
				required: true,
				maxSelections: 1,
			},
			{
				text: "In the past 14 days have you been diagnosed with COVID-19 or asked to quarantine?",
				options: [
					{
						text: "No",
						allowed: true
					},
					{
						text: "Yes",
						allowed: false
					}
				],
				required: true,
				maxSelections: 1,
			},
			{
				text: "In the past 14 days, have you had close contact or high risk exposure to someone with an active or suspected case of COVID-19? This would include being less than 6 feet away for more than 15 minutes in a 24 hour period or direct contact with mucus or saliva.",
				options: [
					{
						text: "No",
						allowed: true
					},
					{
						text: "Yes",
						allowed: false
					}
				],
				required: true,
				maxSelections: 1,
			},
			{
				text: "In the past 10 days have you been asked to get a COVID-19 test due to symptoms or risk of exposure and are still waiting for the results or received an inconclusive result?",
				options: [
					{
						text: "No",
						allowed: true
					},
					{
						text: "Yes",
						allowed: false
					}
				],
				required: true,
				maxSelections: 1,
			},
			{
				text: "If you had a severe case of COVID-19 are you within 20 days of your last symptom? <u>Note:</u> If you are unsure what a severe case of COVID-19 is, please consult your healthcare professional",
				options: [
					{
						text: "No",
						allowed: true
					},
					{
						text: "Yes",
						allowed: false
					}
				],
				required: true,
				maxSelections: 1,
			}
		],
		*/
		
		/*
		venueName: 'Target Center',
		leagueCode: 'nba',
		teamCode: 'min',
		teamCity: 'Minnesota',
		teamMascot: 'Timberwolves',
		colorPrimary: '#002344',
		colorSecondary: '#00466E',
		iOSTicketsUrl: 'yc-nba-min://feature/AXS_FLASH_SEATS',
		androidTicketsUrl: 'yc-nba-min://feature/AXS_FLASH_SEATS',
		questions: [
			{
				text: "Have you experienced any known symptoms of COVID-19 in the preceding 24-hours? Symptoms include: cough, shortness of breath, difficulty breathing, fever, chills, muscle or body aches, headaches, sore throat, new loss of taste or smell, diarrhea, nausea, vomitting, fatigue, congestion, runny nose.",
				options: [
					{
						text: "No",
						allowed: true
					},
					{
						text: "Yes",
						allowed: false
					}
				],
				required: true,
				maxSelections: 1,
			},
			{
				text: "Has anyone you live with or been in contact with been diagnosed with COVID-19 in the preceeding 24-48 hours?",
				options: [
					{
						text: "No",
						allowed: true
					},
					{
						text: "Yes",
						allowed: false
					}
				],
				required: true,
				maxSelections: 1,
			},
			{
				text: "Have you been contacted by a local public health authority within the last 14 days due to having close contact with an individual infected by COVID 19?",
				options: [
					{
						text: "No",
						allowed: true
					},
					{
						text: "Yes",
						allowed: false
					}
				],
				required: true,
				maxSelections: 1,
			},
			{
				text: "Have you been directed to quarantine by a physician or local public health authority?",
				options: [
					{
						text: "No",
						allowed: true
					},
					{
						text: "Yes",
						allowed: false
					}
				],
				required: true,
				maxSelections: 1,
			},
			{
				text: "Have you tested positive for or been diagnosed with COVID-19 within the last 10 days and/or have not received clearance from a physician to discontinue isolation?",
				options: [
					{
						text: "No",
						allowed: true
					},
					{
						text: "Yes",
						allowed: false
					}
				],
				required: true,
				maxSelections: 1,
			}
		],
		*/

		/*
		venueName: 'Vivint Smart Home Arena',
		leagueCode: 'nba',
		teamCode: 'uta',
		teamCity: 'Utah',
		teamMascot: 'Jazz',
		colorPrimary: '#0D223F',
		colorSecondary: '#F89F1F',
		iOSTicketsUrl: 'yc://feature/TM_PRESENCE?hostKey=A3G23g9aG7oeAmAghjmGfTftODa7tSTS&teamDisplayName=Jazz&newAccountManager=false&expAPIKey=qV1rwgLkfBZK7oUBSnUr0W9P&expAPIVersion=toad&logInToSSO=true',
		androidTicketsUrl: 'yc://feature/TM_PRESENCE?clientID=jazz.sdk&uwdKey=56E7C0FD-C980-0CE3-E053-33AAA8C06719&hostKey=30AwdqSWdQZsK05lCRAyx0tIV5tzR4Ge&hostSecret=NTiJEFRUMo8GvtO9&teamDisplayName=Jazz&redirectURI=https%3A%2F%2Fjazz.callback.com%2F&newAccountManager=false&expAPIKey=qV1rwgLkfBZK7oUBSnUr0W9P&expAPIVersion=toad&logInToSSO=true',
		childPluralNoun: 'Attendees',
		childSingularNoun: 'Attendee',
		childPluralPossessive: "Attendees'",
		childQuestionText: 'Are there any others in your party accompanying you to the game?<br><br>By answering <b>Yes</b> and adding names below, you certify that they are not experiencing symptoms of COVID-19.',
		*/
		/*
		venueName: 'STAPLES Center',
		leagueCode: 'nba',
		teamCode: 'lal',
		teamCity: 'Los Angeles',
		teamMascot: 'Lakers',
		colorPrimary: '#552583',
		colorSecondary: '#FDB927',
		iOSTicketsUrl: 'yc://feature/TM_PRESENCE?hostKey=rm9gzGtBVoVjLsyP5NOGsyyYk6rvD2M6&teamDisplayName=Lakers&newAccountManager=false&logInToSSO=true',
		androidTicketsUrl: 'yc://feature/TM_PRESENCE?clientID=lakers.sdk&uwdKey=56E7C0FD-C980-0CE3-E053-33AAA8C06719&hostKey=tEUhFn9gApRMIv2BNQrImsSaGdc1Cwpc&hostSecret=03UbumakFZSAZBTG&teamDisplayName=Lakers&redirectURI=https%3A%2F%2Flakers.callback.com%2F&expSubDomain=lakers&expAppSource=lakers&expAppID=94&expAPIKey=qV1rwgLkfBZK7oUBSnUr0W9P&expAppName=lakers&expAPIVersion=toad&logInToSSO=true',
		*/

		/*
		venueName: 'Amway Center',
		leagueCode: 'nba',
		teamCode: 'orl',
		teamCity: 'Orlando',
		teamMascot: 'Magic',
		colorPrimary: '#006BB7',
		colorSecondary: '#000000',
		iOSTicketsUrl: 'yc://feature/TM_PRESENCE?hostKey=ihj0V7Kbf1uB00Wdj86h9OXhvBQBr8pW&teamDisplayName=Magic&newAccountManager=true&expSubDomain=magic.expapp.com&expAppSource=magic_expapp&expAppID=2&expAPIKey=qV1rwgLkfBZK7oUBSnUr0W9P&expAppName=magic_expapp&expAPIVersion=toad&logInToSSO=true',
		androidTicketsUrl: 'yc://feature/TM_PRESENCE?clientID=magic.sdk&uwdKey=56E7C0FD-C980-0CE3-E053-33AAA8C06719&hostKey=ozRdDNaLBri5HdpCjMzuclcKBIcpVGS4&hostSecret=hOCJuR3yk9Nb4vPv&teamDisplayName=Magic&redirectURI=https%3A%2F%2Fmagic.callback.com%2F&expSubDomain=magic.expapp.com&expAppSource=magic_expapp&expAppID=2&expAPIKey=qV1rwgLkfBZK7oUBSnUr0W9P&expAppName=magic_expapp&expAPIVersion=toad&logInToSSO=true',
		*/

		/*
		venueName: 'Chesapeake Energy Arena',
		leagueCode: 'nba',
		teamCode: 'okc',
		teamCity: 'Oklahoma City',
		teamMascot: 'Thunder',
		colorPrimary: '#007DC3',
		colorSecondary: '#002D62',
		iOSTicketsUrl: 'yc://feature/TM_PRESENCE?clientID=okcnba.sdk&uwdKey=56E7C0FD-C980-0CE3-E053-33AAA8C06719&hostKey=H1JAUZaGOBMEjubTxNGUaAGPyRkvsdRl&hostSecret=zhxEpOcihUkPu54E&teamDisplayName=OKCNBA&redirectURI=https%3A%2F%2Fokcnba.callback.com%2F&expSubDomain=thunder&expAppSource=thunder&expAppID=49&expAPIKey=qV1rwgLkfBZK7oUBSnUr0W9P&expAppName=thunder&expAPIVersion=toad&logInToSSO=true',
		androidTicketsUrl: 'yc://feature/TM_PRESENCE?hostKey=Gn29GRWOxOa1uLneFgP8yx2gG0JcU1GF&teamDisplayName=OKCNBA&newAccountManager=true&expSubDomain=thunder&expAppSource=thunder&expAppID=49&expAPIKey=qV1rwgLkfBZK7oUBSnUr0W9P&expAppName=thunder&expAPIVersion=toad&logInToSSO=true',
		*/

		/*
		venueName: 'TD Garden',
		leagueCode: 'nba',
		teamCode: 'bos',
		teamCity: 'Boston',
		teamMascot: 'Celtics',
		colorPrimary: '#008348',
		colorSecondary: '#000000',
		iOSTicketsUrl: 'yc://feature/TM_PRESENCE?hostKey=1KSjOTQx8oECMoXfqKIcOHUhBcvxVcCx&teamDisplayName=Celtics&newAccountManager=true&expSubDomain=celtics&expAppSource=celticsyinzcam&expAppID=162&expAPIKey=qV1rwgLkfBZK7oUBSnUr0W9P&expAppName=celticsyinzcam&expAPIVersion=toad&logInToSSO=true',
		androidTicketsUrl: 'yc://feature/TM_PRESENCE?clientID=celtics.sdk&uwdKey=56E7C0FD-C980-0CE3-E053-33AAA8C06719&hostKey=R4DIoeQmI8Pt7zQ1dFBiQFe9okRYZ77u&hostSecret=za2tCo6KxmZ6WLuv&teamDisplayName=Celtics&redirectURI=https%3A%2F%2Fceltics.callback.com%2F&expSubDomain=celtics&expAppSource=celticsyinzcam&expAppID=162&expAPIKey=qV1rwgLkfBZK7oUBSnUr0W9P&expAppName=celticsyinzcam&expAPIVersion=toad&logInToSSO=true',
		*/

		/*
		venueName: 'Moda Center',
		leagueCode: 'nba',
		teamCode: 'por',
		teamCity: 'Portland',
		teamMascot: 'Trail Blazers',
		colorPrimary: '#E03A3E',
		colorSecondary: '#000000',
		iOSTicketsUrl: 'yc://feature/TM_PRESENCE?hostKey=297G6r13XyT9cSRlzxBHlAlXhJxTyOH7&teamDisplayName=Trail%20Blazers&newAccountManager=true&expSubDomain=blazers&expAppSource=TrailBlazersRose&expAppID=232&expAPIKey=qV1rwgLkfBZK7oUBSnUr0W9P&expAppName=TrailBlazersRose&expAPIVersion=toad&brandingColor=%23A6192E&logInToSSO=true',
		androidTicketsUrl: 'yc://feature/TM_PRESENCE?clientID=trailblazers.sdk&uwdKey=56E7C0FD-C980-0CE3-E053-33AAA8C06719&hostKey=4DxT4mzwAddgEYmznjparVl9RbAiHovT&hostSecret=M9jv4GN0rGWCQdXZ&teamDisplayName=Trailblazers&redirectURI=https%3A%2F%2Ftrailblazers.callback.com%2F&expSubDomain=blazers&expAppSource=TrailBlazersRose&expAppID=232&expAPIKey=qV1rwgLkfBZK7oUBSnUr0W9P&expAppName=Trail%20BlazersRose&expAPIVersion=toad&brandingColor=%23A6192E&logInToSSO=true',		
		questions: [
			{
				text: "<b>Have you experienced any of the following symptoms in the past 48 hours:</b><br>• fever or chills<br>• cough<br>• shortness of breath or difficulty breathing<br>• fatigue<br>• muscle or body aches<br>• headache<br>• new loss of taste or smell<br>• sore throat<br>• congestion or runny nose<br>• nausea or vomiting<br>• diarrhea",
				options: [ { text: "No", allowed: true }, { text: "Yes", allowed: false } ], required: true, maxSelections: 1,
			},
			{
				text: "<b>Within the past 14 days, have you tested positive for COVID-19?</b>",
				options: [ { text: "No", allowed: true }, { text: "Yes", allowed: false } ], required: true, maxSelections: 1,
			},
			{
				text: "<b>Within the past 14 days, have you been in close physical contact (6 feet or closer for a cumulative total of 15 minutes) with:</b><br>• Anyone who is known to have laboratory-confirmed COVID-19?<br><b>OR</b><br>• Anyone who has any symptoms consistent with COVID-19?",
				options: [ { text: "No", allowed: true }, { text: "Yes", allowed: false } ], required: true, maxSelections: 1,
			},
			{
				text: "<b>Are you isolating or quarantining because you may have been exposed to a person with COVID-19 or are worried that you may be sick with COVID-19?</b>",
				options: [ { text: "No", allowed: true }, { text: "Yes", allowed: false } ], required: true, maxSelections: 1,
			},
			{
				text: "<b>Are you currently waiting on the results of a COVID-19 test?</b>",
				options: [ { text: "No", allowed: true }, { text: "Yes", allowed: false } ], required: true, maxSelections: 1,
			}
		],

		/*
		venueName: 'Capital Wrestling Center',
		leagueCode: 'venue',
		teamCode: 'wwe',
		teamCity: 'WWE',
		teamMascot: 'NXT',
		colorPrimary: '#F9E400',
		colorSecondary: '#000000',
		showTicketsButton: false,
		iOSTicketsUrl: 'yc://action/NOOP',
		androidTicketsUrl: 'yc://action/NOOP',
		eventIdOverride: 1,
		welcomeMessageOverride: 'Welcome to Capital Wrestling Center. The safety of NXT fans is our highest priority. To prevent the spread of COVID-19 and reduce the risk of exposure to other fans, we are conducting a simple screening questionnaire. Your participation is important to take the proper precautionary measures to help protect everyone in attending the event.',
		questions: [
			{
				text: "Have you, or any members in your household, traveled out of the United States in the last 14 days?",
				options: [
					{
						text: "No",
						allowed: true
					},
					{
						text: "Yes",
						allowed: false
					}
				],
				required: true,
				maxSelections: 1,
			},
			{
				text: "Have you been in close contact* with any person diagnosed (laboratory confirmed) with the Coronavirus (COVID-19)?<br><br>*Close contact as defined by:<br>- Being within approximately 6 feet (2 meters) of a COVID-19 case for a prolonged period of time; close contact can occur while caring for, living with, visiting, or share a healthcare waiting area or room with a COVID-19 case, or<br>- Having direct contact with infectious secretions of a COVID-19 case (e.g being coughed or sneezed on)",
				options: [
					{
						text: "No",
						allowed: true
					},
					{
						text: "Yes",
						allowed: false
					}
				],
				required: true,
				maxSelections: 1,
			},
			{
				text: "Have you experienced any of the following symptoms in the last 2-14 days:  Fever or chills, cough, shortness of breath, difficulty breathing or chest tightness, fatigue, muscle or body aches, headache, new loss of taste or smell, sore throat, congestion or runny nose, nausea or vomiting, diarrhea?",
				options: [
					{
						text: "No",
						allowed: true
					},
					{
						text: "Yes",
						allowed: false
					}
				],
				required: true,
				maxSelections: 1,
			}
		],
		*/

		venueName: 'Spectrum Center',
		leagueCode: 'nba',
		teamCode: 'cha',
		teamCity: 'Charlotte',
		teamMascot: 'Hornets',
		colorPrimary: '#00788C',
		colorSecondary: '#1d1160',
		iOSTicketsUrl: 'yc://feature/TM_PRESENCE?hostKey=a7NX7A6gJx0OUmcywGMpGeC4C7Gwbl6x&teamDisplayName=Hornets&newAccountManager=true&logInToSSO=true&title=MY%20EVENTS',
		androidTicketsUrl: 'yc://feature/TM_PRESENCE?clientID=charhornets.sdk&uwdKey=56E7C0FD-C980-0CE3-E053-33AAA8C06719&hostKey=t8GXBAIsRAil8gfIXAA5uZdgyxWAGzUS&hostSecret=1LjtKIdK4cqGUS5z&teamDisplayName=Hornets&redirectURI=https%3A%2F%2Fcharhornets.callback.com%2F&logInToSSO=true&title=MY%20EVENTS',		
		childPluralNoun: 'Attendees',
		childSingularNoun: 'Attendee',
		childPluralPossessive: "Attendees'",
		childQuestionText: 'Are there any children or other attendees accompanied by you for the scheduled event?',
		questions: [
			{
				text: "Do you live with or have you been in contact with anyone diagnosed with COVID-19 in the last 24-48 hours?",
				options: [ { text: "No", allowed: true }, { text: "Yes", allowed: false } ], required: true, maxSelections: 1,
			},
			{
				text: "Have you been contacted by a local health official within the last 14 days due to having had close contact with an individual infected with COVID-19?",
				options: [ { text: "No", allowed: true }, { text: "Yes", allowed: false } ], required: true, maxSelections: 1,
			},
			{
				text: "Have you tested positive for, or been diagnosed with, COVID-19 within the last 10 days, or not received clearance from a physician to discontinue isolation?",
				options: [ { text: "No", allowed: true }, { text: "Yes", allowed: false } ], required: true, maxSelections: 1,
			},
			{
				text: "Have you recently experienced any of the following symptoms?  If yes, select all that apply.  If none, leave blank:",
				options: [
					{
						text: "Cough",
						allowed: false
					},
					{
						text: "Shortness of Breath",
						allowed: false
					},
					{
						text: "Fatigue",
						allowed: false
					},
					{
						text: "Muscle/body aches",
						allowed: false
					},
					{
						text: "Headache",
						allowed: false
					},
					{
						text: "New loss of taste or smell",
						allowed: false
					},
					{
						text: "Sore throat",
						allowed: false
					},
					{
						text: "Congestion or runny nose",
						allowed: false
					},
					{
						text: "Nausea or vomiting",
						allowed: false
					},
					{
						text: "Diarrhea",
						allowed: false
					}
				],
			}
		],

		isAnonymous: (qs?.anonymous === 'true'),
		_questions: [
			{
				text: "In the past 14 days, have you tested positive for COVID-19?",
				options: [
					{
						text: "No",
						allowed: true
					},
					{
						text: "Yes",
						allowed: false
					}
				],
				required: true,
				maxSelections: 1,
			},
			{
				text: "In the past 14 days, have you been in contact with anyone who has tested positive for COVID-19?",
				options: [
					{
						text: "No",
						allowed: true
					},
					{
						text: "Yes",
						allowed: false
					}
				],
				required: true,
				maxSelections: 1,
			},
			{
				text: "Have you recently experienced any of the listed symptoms of COVID-19? Select all that apply. Leave the question blank if none apply.",
				options: [
					{
						text: "Cough",
						allowed: false
					},
					{
						text: "Muscle Pain",
						allowed: false
					},
					{
						text: "Sore Throat",
						allowed: false
					},
					{
						text: "Loss of Taste",
						allowed: false
					},
					{
						text: "Loss of Smell",
						allowed: false
					},
					{
						text: "Fatigue",
						allowed: false
					}
				],
				required: false,
				maxSelections: null,
			},
		],
	}
});

export default app;